var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('Navbar'),_c('home-banner'),_c('Section',{staticClass:"mb-5",attrs:{"title":"Create Account","small-text":"Join us to make your brand bigger.","component-name":"Signup"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }